import { createContext, useContext, useEffect, type ReactNode } from "react";
import { brand, applyBrand, type Brand } from "./brand.config";
import "./tokens.css";

const BrandContext = createContext<Brand>(brand);

export function ThemeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    applyBrand(brand);
  }, []);
  return (
    <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>
  );
}

export function useBrand(): Brand {
  return useContext(BrandContext);
}
